<template>
    <div class="container repair-container" v-if="asset">

        <div class="row">
            <div class="col-9">
                <h3 class="mt-4">
                    Upload Photos
                </h3>
            </div>
            <div class="col-3">
                <div class="">
                    <div class="card-link-container">
                        <input type="file" name="frontPhoto" id="frontPhoto" class="file-input" accept="image/*"
                               capture="environment"
                               @change="uploadPhoto('after-front', 'frontPhoto')">
                        <label class="card card-body card-link no-icon text-sm p-3 flex-row bg-gradient-info"
                               for="frontPhoto">
                            <icon-device-front
                              size="md"
                              class="icon-all-white m-0 mr-2">
                            </icon-device-front>
                            Add Photo
                        </label>
                    </div>
                </div>
            </div>
        </div>
        <!-- Links -->


        <div class="alert alert-warning">
            <animated-warning></animated-warning>
            <div class="alert-content">
                Please supply photos of the device powered on
            </div>
        </div>

        <!-- Empty state -->
        <div class="card card-body" v-if="!imagePaths.length">
            <empty-state
              emptyIcon
              icon="camera"
              title="No photos uploaded"
              subtitle="Select one of the options above to add a photo">
            </empty-state>
        </div>

        <!-- List of photos -->
        <template>
            <div class="card-grid grid-col-2 grid-col-md-3">
                <image-item
                  v-for="(imagePath, key) in imagePaths" :key="key"
                  :imageType="imagePath.type"
                  :imageData="imagePath.path">
                </image-item>
            </div>
        </template>

        <!-- Footer -->
        <div class="card card-body" v-if="imagePaths.length">
            <button type="button" @click="goBackToAssetPage" class="btn btn-light">Scan another Asset</button>
        </div>

        <!-- Image preview modal -->
        <repair-image-modal></repair-image-modal>

    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

import Compressor from 'compressorjs';

export default {

    props: ['assetId'],

    data() {
        return {
            imagePaths: [],
            isLoadingImages: false
        }
    },

    mounted() {
        this.loadAsset({
            assetId: this.assetId,
        });
        //   .then(() => {
        //
        // });

        this.listImages();
    },

    computed: {
        ...mapGetters([
            "asset",
        ]),

        jobId() {
            if (this.asset) {
                return this.asset.job_id;
            }
            return null;
        },

        deviceId() {
            if (this.asset) {
                return this.asset.owner_id;
            }
            return null;
        },
    },

    methods: {
        ...mapActions([
            "loadAsset",
            "addDeviceImage",
            "displayToast",
        ]),

        /** Compress and upload photo */
        uploadPhoto(type, elementId) {
          const filePicker = document.getElementById(elementId);

          if (!filePicker || !filePicker.files || filePicker.files.length <= 0) {
            this.displayToast({text: 'No file selected.', type: 'error'});
            return;
          }

          let self = this;
          new Compressor(filePicker.files[0], {
            quality: 0.6,
            mimeType: 'image/jpeg',
            maxWidth: 1920,
            maxHeight: 1920,
            success(result) {

              const data = new FormData();
              data.append('image', result);
              data.set('device_id', self.deviceId);
              data.set('type', type);

              self.displayToast({text: 'File is being uploaded.', type: 'success'});

              self.$http.post(
                  '/api/v4/upload-image',
                  data,
                  {
                    headers: {
                      'Content-Type': 'multipart/form-data',
                    },
                  },
              ).then((response) => {
                self.imagePaths.push(response.data.data);
                self.displayImage(result);
              }).catch((error) => {
                console.log(error);
                const message = error?.response?.statusText ?? 'Error uploading file';
                self.displayToast({text: message, type: 'error'});
              });

            },
            error() {
              self.displayToast({text: 'Could not parse file.', type: 'error'});
              filePicker.value = "";
            },
          });
        },

        /** Display the image just taken using base64data */
        displayImage(myFile) {
        return new Promise((resolve, reject) => {
          const fileReader = new FileReader();
          if (fileReader && myFile) {
            fileReader.readAsDataURL(myFile);
            fileReader.onload = () => {
              resolve(fileReader.result);
            };

            fileReader.onerror = (error) => {
              reject(error);
            };
          } else {
            reject('No file provided');
          }
        });
      },

        /** List images from database storage */
        listImages() {
          this.isLoadingImages = true;

          this.$http.get(`/api/v4/images/${this.deviceId}`)
              .then((response) => {
                const items = response.data.data;

                const urls = items.map(item => {
                  // Extract type from the title (e.g., "moh-after-back")
                  const splitTitle = item.title.split("-");
                  const type = splitTitle.length > 2 ? `${splitTitle[1]}-${splitTitle[2]}` : splitTitle[1] ?? "other";

                  return {
                    path: item.path, // This is the actual image URL
                    type: type
                  };
                });

                this.imagePaths = urls;
              })
              .catch(error => {
                console.error("Error fetching images:", error);
                this.displayToast({
                  text: error?.response?.statusText ?? "Error fetching images",
                  type: "error"
                });
              })
              .finally(() => {
                this.isLoadingImages = false;
              });
        },

        goBackToAssetPage() {
            return this.$router.push({
                name: 'bulkRepairImeiSearch',
                params: {
                    assetId: this.asset.id
                }
            });
        },
    }
}
</script>

<style scoped>

</style>